import RestaurantOtherItem from './RestaurantOtherItem';

export default RestaurantOtherItem;
